import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import { ToastsContainer, ToastsStore } from 'react-toasts';

import AuthenticationService from '../services/AuthenticationService';
import MenuComponent2 from './MenuComponent2';
import ItemButtons from './ItemButtons';
import UserDataService from '../services/UserDataService';
import ItemDataService from '../services/ItemDataService';
import "../css/style.css";
import { MdDeleteForever, MdModeEdit, MdImportExport } from 'react-icons/md';
import { FaFilter, FaStoreAlt } from 'react-icons/fa';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import { DATA_TYPE_MASTER_ITEM } from '../constants';
import DataUtil from '../utilities/DataUtil';

import { ICON_COLOR } from '../icon';
import ShopDataService from '../services/ShopDataService';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FileUploader from './FileUploader';
import DhlUploader from './DhlUploader';

class ItemList extends Component {
  constructor() {
    super();

    this.state = {
      items: [],
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          Header: couterpart.translate('item_sku'),
          accessor: 'sku'
        }, {
          Header: couterpart.translate('shop_item'),
          accessor: 'id',
          width: 150,
          Cell: row => (
            this.getShopItemButton(row)
          )
        }, {
          Header: couterpart.translate('dhl_items'),
          accessor: 'id',
          width: 150,
          Cell: row => (
            this.getDHLsButton(row)
          )
        }, {
          Header: couterpart.translate('item_semi'),
          accessor: 'semi'
        }, {
          Header: couterpart.translate('action'),
          accessor: 'action',
          width: 300,
          Cell: row => (
            this.getFunctionButtons(row)
          )
        }],
      showShop: false,
      showShopAssigning: false,
      showDetails: false,
      selectedShopId: 0,
      shops: [],
      searchingShopName: '',
    };
  }

  handleClose() {
    this.setState({ showShop: false });
  }

  handleShopAssignSaving() {
    ShopDataService.saveShopItem({
      shopId: this.state.selectedShopId,
      itemId: this.state.selectedItemId
    }).then(data => {
      if (data.id !== undefined && data.id > 0) {
        this.loadUnassignedShops(this.state.selectedItemId);
        ShopDataService.retrieveShopsByItem(this.state.selectedItemId).then(data => {
          if (data.message === undefined) {
            this.setState({
              shopsByItem: data
            });
          }
        });
      } else {
        alert("Không thể assign shop to item.");
      }
    });
  }

  handleShopAssigningClose() {
    this.setState({ showShopAssigning: false });
  }

  handleDetailsClose() {
    this.setState({ showDetails: false });
  }

  getShopItemButton(row) {
    let limitUser = sessionStorage.getItem('limitUser');
    if (AuthenticationService.isAdmin() || (AuthenticationService.isService() && limitUser !== '2')) {
      return (
        <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleShowShopItem(row.original)}>
            <FaStoreAlt color={ICON_COLOR} /></button>
        </div>
      );
    }

    return (<div>{sessionStorage.getItem('workingShop')}</div>)
  }

  getDHLsButton(row) {
    if (AuthenticationService.isAdmin() || (AuthenticationService.isService())) {
      return (
        <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleShowDetails(row.original)}>
            <FaStoreAlt color={ICON_COLOR} /></button>
        </div>
      );
    }

    return (<></>);
  }

  getFunctionButtons(row) {
    let limitUser = sessionStorage.getItem('limitUser');
    if (AuthenticationService.isAdmin() || (AuthenticationService.isService() && limitUser !== '2')) {
      return (
        <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleEdit(row.original)}>
            <MdModeEdit color={ICON_COLOR} />&nbsp;
            {couterpart.translate('button_edit')}</button>&nbsp;
          <button className="myButton" onClick={() => this.handleDelete(row.original)}>
            <MdDeleteForever color={ICON_COLOR} />&nbsp;
            {couterpart.translate('button_delete')}</button>
          <button className="myButton" onClick={() => this.handleShowShopAssigning(row.original)}>
            <FaStoreAlt color={ICON_COLOR} />&nbsp;
            {couterpart.translate('button_assign_shop')}</button>
          <button className="myButton" onClick={() => this.handleShowDetails(row.original)}>
            <FaStoreAlt color={ICON_COLOR} />&nbsp;
            {couterpart.translate('button_details')}</button>
        </div>
      )
    }

    if (AuthenticationService.isService() && limitUser === '2') {
      return (
        <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleEdit(row.original)}>
            <MdModeEdit color={ICON_COLOR} />&nbsp;
            {couterpart.translate('button_edit')}</button>&nbsp;
          <button className="myButton" onClick={() => this.handleDelete(row.original)}>
            <MdDeleteForever color={ICON_COLOR} />&nbsp;
            {couterpart.translate('button_delete')}</button>
        </div>
      )
    }

    return (<div>&nbsp;</div>)
  }

  componentDidMount() {
    this.loadShops();
    let searchValue = WorkOrderUtil.getItem('items.searchValue') ? WorkOrderUtil.getItem('items.searchValue') : ''

    let tmp = WorkOrderUtil.getItem('items.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }

    if (AuthenticationService.isAdmin()) {
      ItemDataService.retrieveBy(searchValue).then(data => {
        let selected = WorkOrderUtil.getItem('items.selectedRow') ? parseInt(WorkOrderUtil.getItem('items.selectedRow')) : 0;
        if (data.message === undefined) {
          this.setState({ items: data, searchValue: searchValue, selectedRow: selected, selectedPage: iSelectPage })
        } else {
          this.setState({ items: [], searchValue: searchValue, selectedRow: selected, selectedPage: iSelectPage })
          ToastsStore.error(data.message);
        }
      });
    } else {
      ItemDataService.retrieveByShopAndBy(searchValue).then(data => {
        let selected = WorkOrderUtil.getItem('items.selectedRow') ? parseInt(WorkOrderUtil.getItem('items.selectedRow')) : 0;
        if (data.message === undefined) {
          this.setState({ items: data, searchValue: searchValue, selectedRow: selected, selectedPage: iSelectPage })
        } else {
          this.setState({ items: [], searchValue: searchValue, selectedRow: selected, selectedPage: iSelectPage })
          ToastsStore.error(data.message);
        }
      });
    }
  }

  handleView(e) {
    this.props.history.push("/items/view/" + e.id);
  }

  handleEdit(e) {
    this.props.history.push("/items/edit/" + e.id);
  }

  handleDelete(e) {
    ItemDataService.delete(e.id).then(data => {
      if (data.message === undefined) {
        if (AuthenticationService.isAdmin()) {
          ItemDataService.retrieveBy(undefined).then(data => {
            this.setState({ items: data })
          });
        } else {
          ItemDataService.retrieveByShopAndBy(undefined).then(data => {
            this.setState({ items: data })
          });
        }
      }
    });
  }

  handleShowShopItem(e) {
    ShopDataService.retrieveShopsByItem(e.id).then(data => {
      if (data.message === undefined) {
        this.setState({
          showShop: true,
          shopsByItem: data
        });
      }
    });
  }

  handleShowShopAssigning(e) {
    this.loadUnassignedShops(e.id);
    ShopDataService.retrieveShopsByItem(e.id).then(data => {
      if (data.message === undefined) {
        this.setState({
          showShopAssigning: true,
          shopsByItem: data,
          selectedItemId: e.id
        });
      }
    });
  }

  handleShowDetails(e) {
    ItemDataService.retrieveDHLsBySku(e.sku).then(data => {
      console.log(data);
      if (data.message === undefined) {
        this.setState({
          showDetails: true,
          dhls: data,
          selectedItemId: e.id
        });
      }
    });
  }

  handleDeleteShopItem(shopId) {
    ShopDataService.deleteShopItem({
      shopId: shopId,
      itemId: this.state.selectedItemId
    }).then(data => {
      if (data.id !== undefined && data.id > 0) {
        this.loadUnassignedShops(this.state.selectedItemId);
        ShopDataService.retrieveShopsByItem(this.state.selectedItemId).then(data => {
          if (data.message === undefined) {
            this.setState({
              shopsByItem: data
            });
          }
        });
      } else {
        alert("Không thể xóa assign shopitem.");
      }
    });
  }

  handleDeleteDhl(dhlId, sku) {
    let ret = window.confirm(couterpart.translate('msg_delete_dhl_confirm'));
        if (ret === true){
          ItemDataService.deleteDHL(dhlId).then(data => {
            if (data === 1) {
              ItemDataService.retrieveDHLsBySku(sku).then(data => {
                if (data.message === undefined) {
                  this.setState({
                    dhls: data
                  });
                }
              });
            } else {
              alert("Không thể xóa dhl.");
            }
          });
        }
  }

  renderShops() {
    if (this.state.shopsByItem === undefined || this.state.shopsByItem === null || !(this.state.shopsByItem instanceof Array)) {
      return (<></>);
    }
    return (
      <table border="1" cellPadding="2" cellSpacing="2" width="100%">
        <tbody>
          <tr>
            <th>
              {'Stt'}
            </th>
            <th>
              {'Tên'}
            </th>
            <th width="55">
              {'  '}
            </th>
          </tr>
          {this.state.shopsByItem.map((shop, index) => {
            if (index % 2 === 0) {
              return (
                <tr style={{ backgroundColor: "lightblue" }} key={shop.id + "_" + index}>
                  <td>
                    <label className="label_link">{index + 1}</label>
                  </td>
                  <td>
                    <label className="label_link">{shop.name}</label>
                  </td>
                  <td>
                    <button className="myButton" onClick={() => this.handleDeleteShopItem(shop.id)}>
                      <MdDeleteForever color={ICON_COLOR} />&nbsp;{couterpart.translate('button_delete')}
                    </button>
                  </td>
                </tr>
              )
            } else {
              return (
                <tr style={{ backgroundColor: "white" }} key={shop.code + "_" + index}>
                  <td>
                    <label className="label_link">{index + 1}</label>
                  </td>
                  <td>
                    <label className="label_link">{shop.name}</label>
                  </td>
                  <td>
                    <button className="myButton" onClick={() => this.handleDeleteShopItem(shop.id)}>
                      <MdDeleteForever color={ICON_COLOR} />&nbsp;{couterpart.translate('button_delete')}
                    </button>
                  </td>
                </tr>
              )
            }
          })
          }
        </tbody>
      </table>)
  }

  renderDhl() {
    if (this.state.dhls === undefined || this.state.dhls === null || !(this.state.dhls instanceof Array)) {
      return (<></>);
    }
    return (
      <table border="1" cellPadding="2" cellSpacing="2" width="100%">
        <tbody>
          <tr>
            <th width="1%">
              {'Stt'}
            </th>
            <th width="10%">
              {'Mã'}
            </th>
            <th width="20%">
              {'Tên'}
            </th>
            <th width="20%">
              {'Nhóm'}
            </th>
            <th width="20%">
              {'Nhóm EN'}
            </th>
            <th width="25%">
              {'DHL Description'}
            </th>
            <th width="2%">
              {'Priority'}
            </th>
            <th width="2%">
              {'  '}
            </th>
          </tr>
          {this.state.dhls.map((dhl, index) => {
            if (index % 2 === 0) {
              return (
                <tr style={{ backgroundColor: "lightblue" }} key={dhl.id + "_" + index}>
                  <td>
                    <label className="label_link">{index + 1}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.maVthh}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.tenVthh}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.nhomTenHh }</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.nhomTenHhEn}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.dhlDescription}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.sortOrder}</label>
                  </td>
                  <td>
                    <button className="myButton" onClick={() => this.handleDeleteDhl(dhl.id, dhl.maVthh)}>
                      <MdDeleteForever color={ICON_COLOR} />&nbsp;{couterpart.translate('button_delete')}
                    </button>
                  </td>
                </tr>
              )
            } else {
              return (
                <tr style={{ backgroundColor: "white" }} key={dhl.id + "_" + index}>
                  <td>
                    <label className="label_link">{index + 1}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.maVthh}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.tenVthh}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.nhomTenHh }</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.nhomTenHhEn}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.dhlDescription}</label>
                  </td>
                  <td>
                    <label className="label_link">{dhl.sortOrder}</label>
                  </td>
                  <td>
                    <button className="myButton" onClick={() => this.handleDeleteDhl(dhl.id, dhl.maVthh)}>
                      <MdDeleteForever color={ICON_COLOR} />&nbsp;{couterpart.translate('button_delete')}
                    </button>
                  </td>
                </tr>
              )
            }
          })
          }
        </tbody>
      </table>)
  }

  handleChange(e) {
    var value = e.target.value;
    sessionStorage.setItem("items.searchValue", value)
    if (value === undefined || value.length < 1) {
      this.setState({
        searchValue: ''
      });
    }
    else {
      this.setState(prevState => ({
        searchValue: value
      }));
    }
  }

  onFilter(e) {
    if (AuthenticationService.isAdmin()) {
      ItemDataService.retrieveBy(this.state.searchValue, this.state.searchingShopName, this.state.detailsRequired).then(data => {
        if (data.message === undefined) {
          this.setState({ items: data })
        } else {
          this.setState({ items: [] })
          ToastsStore.error(data.message);
        }
      });
    } else {
      ItemDataService.retrieveByShopAndBy(this.state.searchValue, this.state.detailsRequired).then(data => {
        if (data.message === undefined) {
          this.setState({ items: data })
        } else {
          this.setState({ items: [] })
          ToastsStore.error(data.message);
        }
      });
    }
  }

  exportExcel() {
    UserDataService.retrieveNextFilename(DATA_TYPE_MASTER_ITEM).then(res => {
      ItemDataService.exportExcel().then(data => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', res.filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        DataUtil.sleep(1000).then(() => { this.setState({ spinnerVisible: false }); });
      });
    });
  }

  exportDHL() {
    ItemDataService.exportDhl().then(data => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'dhl.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      DataUtil.sleep(1000).then(() => { this.setState({ spinnerVisible: false }); });
    });
  }

  renderShopList() {
    let options = this.state.unassignedShops !== undefined ? this.state.unassignedShops : []
    return (
      <select className="selectBox4" value={this.state.selectedShopId} onChange={this.handleSelectChange.bind(this)} name="selectedShopId">
        <option key="empty" value=""></option>
        {options.map(option => this.renderShopOption(option))}
      </select>
    );
  }

  renderAllShopList() {
    if (!AuthenticationService.isAdmin()) {
      return (<>&nbsp;</>);
    }
    let options = this.state.shops !== undefined ? this.state.shops : []
    return (
      <select className="selectBox4" value={this.state.searchingShopName} onChange={this.handleSelectChange.bind(this)} name="searchingShopName">
        <option key="empty" value=""></option>
        {options.map(option => this.renderAllShopOption(option))}
      </select>
    );
  }

  handleSelectChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({ [name]: value });
  }

  renderShopOption(option) {
    return (
      <option key={option.id} value={option.id}>{option.name}</option>
    );
  }

  renderAllShopOption(option) {
    return (
      <option key={option.name} value={option.name}>{option.name}</option>
    );
  }

  loadUnassignedShops(itemId) {
    ShopDataService.retrieveUnassignedShopsByItem(itemId).then(data => {
      if (data.message === undefined) {
        this.setState({ unassignedShops: data })
      } else {
        this.setState({ unassignedShops: [] })
      }
    });
  }

  loadShops() {
    ShopDataService.retrieveShops().then(data => {
      if (data.message === undefined) {
        this.setState({ shops: data })
      } else {
        this.setState({ shops: [] })
      }
    });
  }

  handleDetailsRequired(value) {
    if (this.state.detailsRequired === 1) {
      this.setState({ detailsRequired: 0 });
    } else {
      this.setState({ detailsRequired: 1 });
    }
  }

  handleUpload() {

  }

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()) {
      return (<div>Unauthorized access.</div>);
    }
    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <div className="row">
          <div className="col-3">
            <ItemButtons />
          </div>
          <div className='col-3'>
            <button className="myButton" onClick={this.exportDHL.bind(this)}><MdImportExport color={ICON_COLOR} />&nbsp;{couterpart.translate('button_export_dhl')}</button>
          </div>
           <div className='col-6'>
            <DhlUploader handleUpdate={this.handleUpload.bind(this)} />
          </div>
        </div>
        <div className="row">
          <div className="col-8">
            <div className="row">
              <div className="col-2"><input type="text" defaultValue={this.state.searchValue} placeholder={couterpart.translate('item_sku')} onChange={this.handleChange.bind(this)} style={{ margin: "5px", width: "100%" }} /></div>
              <div className="col-3">
                {this.renderAllShopList()}
              </div>
              <div className="col-3">
                <div style={{ display: 'inline-flex' }} className="col-lg-12">
                  <input type="checkbox" name="isUrgentByCustomer" className="inputBox" style={{ marginTop: '10px' }} value={1}
                    onChange={this.handleDetailsRequired.bind(this, 1)} />
                  <label className="col-lg-12 Legends-alphabet" style={{ marginTop: '10px' }}> {couterpart.translate('no_details')}</label>
                </div>
              </div>
              <div className="col-2">
                <button className="myButton" onClick={this.onFilter.bind(this)}><FaFilter color={ICON_COLOR} />&nbsp;{couterpart.translate('button_filter')}</button>
              </div>
              <div className="col-1">
                <button className="myButton" onClick={this.exportExcel.bind(this)}><MdImportExport color={ICON_COLOR} />&nbsp;{couterpart.translate('button_export')}</button>
              </div>
            </div>
          </div>
        </div>
        <ReactTable
          NoDataComponent={() => null}
          // PaginationComponent={ReactTablePagination}
          previousText={"<"}
          nextText={">"}
          data={this.state.items}
          columns={this.state.columns}
          page={this.state.selectedPage}
          defaultPageSize={10}
          showPageSizeOptions={true}
          onPageChange={(pageIndex) => {
            this.setState({ selectedPage: pageIndex })
            WorkOrderUtil.saveItem('items.selectedPage', pageIndex)
          }}
          pageSizeOptions={[3, 5, 10, 20]}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: (e) => {
                  this.setState({
                    selectedRow: rowInfo.index,
                    itemId: rowInfo.original.id
                  }, () => {
                    WorkOrderUtil.saveItem('items.selectedRow', this.state.selectedRow);
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                  color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                }
              }
            } else {
              return {}
            }
          }
          }
        />
        <Modal show={this.state.showShop} onHide={this.handleClose.bind(this)} backdrop="static" dialogClassName="modal-60w">
          <Modal.Header closeButton>
            <Modal.Title>Assigned shops</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                {this.renderShops()}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose.bind(this)}>Đóng</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showShopAssigning} onHide={this.handleShopAssigningClose.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Assign shops to item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                Unassigned shops
              </div>
            </div>
            <div className="row">
              <div className="col-10">
                <div style={{ display: 'inline-table' }}>
                  <div style={{ display: 'table-cell' }}>{this.renderShopList()}</div>
                  <div style={{ display: 'table-cell' }}>
                    <button className="myButton3" onClick={() => this.handleShopAssignSaving()}>
                      <FaStoreAlt color={ICON_COLOR} />&nbsp;
                      {couterpart.translate('button_assign')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                Assigned shops
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderShops()}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleShopAssigningClose.bind(this)}>Đóng</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showDetails} onHide={this.handleDetailsClose.bind(this)} backdrop="static" dialogClassName="modal-60w">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin DHL</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                {this.renderDhl()}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleDetailsClose.bind(this)}>Đóng</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default ItemList;